
/**
 * 토픽 상세 정보
 */
export type ExploreContentItemContentOneOfThreesevenDetails = {
  description?: string;
};
